import React, { useEffect } from "react";

function ViewCustomerDetails({ userData, isOpen, onClose }) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        onClick={onClose}
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
      />

      {/* ✅ Modal Card (YOU MISSED THIS) */}
      <div className="relative bg-white w-[95%] max-w-2xl rounded-2xl shadow-2xl p-8 z-50">
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-4 mb-6">
          <h2 className="text-xl font-semibold text-gray-800">
            User Details
          </h2>

          <button
            onClick={onClose}
            className="text-gray-400 hover:text-red-500 text-xl"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">
          <div>
            <p className="text-gray-500">User ID</p>
            <p className="font-medium text-gray-800">{userData?.user_id}</p>
          </div>

          <div>
            <p className="text-gray-500">Mobile Number</p>
            <p className="font-medium text-gray-800">
              {userData?.mobile_number || "—"}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Email</p>
            <p className="font-medium text-gray-800">
              {userData?.email_address || "—"}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Aadhar Number</p>
            <p className="font-medium text-gray-800">
              {userData?.aadhar_number || "—"}
            </p>
          </div>

          <div>
            <p className="text-gray-500">PAN Number</p>
            <p className="font-medium text-gray-800">
              {userData?.pan_number || "—"}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Pin Code</p>
            <p className="font-medium text-gray-800">
              {userData?.pin_code || "—"}
            </p>
          </div>

          <div className="sm:col-span-2">
            <p className="text-gray-500">Address</p>
            <p className="font-medium text-gray-800">
              {userData?.signatory_address || userData?.landmark_address || "—"}
            </p>
          </div>

          <div>
            <p className="text-gray-500">KYC Status</p>
            <p className="font-medium text-gray-800 capitalize">
              {userData?.digital_kyc_status || "—"}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Physical KYC</p>
            <p className="font-medium text-gray-800 capitalize">
              {userData?.physical_kyc_status || "—"}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Account Status</p>
            <p className="font-medium text-gray-800 capitalize">
              {userData?.account_status || "—"}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Created On</p>
            <p className="font-medium text-gray-800">{userData?.doc || "—"}</p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 text-right">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewCustomerDetails;
